import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Portal from 'layout/atoms/Portal/Portal';
import styles from './Tooltip.module.scss';
function Tooltip({ theme = 'default', size = 'm', maxWidth = 400, position = 'top', delay = 2000, content, children, }) {
    const [visible, setVisible] = useState(false);
    const triggerRef = useRef(null);
    const timeoutRef = useRef(null);
    const hideTimeoutRef = useRef(null);
    const [tooltipStyles, setTooltipStyles] = useState(undefined);
    const calculatePosition = useCallback(() => {
        if (!triggerRef.current)
            return;
        const rect = triggerRef.current.getBoundingClientRect();
        const styles = {
            position: 'absolute',
        };
        const offset = 10;
        switch (position) {
            case 'top':
                styles.top = rect.top + window.scrollY - offset;
                styles.left = rect.left + window.scrollX + rect.width / 2;
                styles.transform = 'translate(-50%, -100%)';
                break;
            case 'bottom':
                styles.top = rect.bottom + window.scrollY + offset;
                styles.left = rect.left + window.scrollX + rect.width / 2;
                styles.transform = 'translateX(-50%)';
                break;
            case 'left':
                styles.top = rect.top + window.scrollY + rect.height / 2;
                styles.left = rect.left + window.scrollX - offset;
                styles.transform = 'translate(-100%, -50%)';
                break;
            case 'right':
                styles.top = rect.top + window.scrollY + rect.height / 2;
                styles.left = rect.right + window.scrollX + offset;
                styles.transform = 'translateY(-50%)';
                break;
            default:
                break;
        }
        setTooltipStyles(styles);
    }, [position]);
    const handleMouseEnter = () => {
        if (hideTimeoutRef.current) {
            clearTimeout(hideTimeoutRef.current);
            hideTimeoutRef.current = null;
        }
        calculatePosition();
        timeoutRef.current = window.setTimeout(() => {
            setVisible(true);
        }, delay);
    };
    const handleMouseLeave = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        hideTimeoutRef.current = window.setTimeout(() => {
            setVisible(false);
        }, 100);
    };
    const handleTooltipMouseEnter = () => {
        if (hideTimeoutRef.current) {
            clearTimeout(hideTimeoutRef.current);
            hideTimeoutRef.current = null;
        }
    };
    const handleTooltipMouseLeave = () => {
        setVisible(false);
    };
    useEffect(() => {
        window.addEventListener('resize', calculatePosition);
        return () => window.removeEventListener('resize', calculatePosition);
    }, [calculatePosition]);
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
            }
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: triggerRef, className: styles.trigger, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, children),
        visible && (React.createElement(Portal, null,
            React.createElement("div", { className: classNames(styles.tooltip, {
                    [styles[theme]]: theme !== 'none',
                    [styles[position]]: theme !== 'none',
                }), style: Object.assign(Object.assign({}, tooltipStyles), { maxWidth: maxWidth === false ? undefined : maxWidth }), onMouseEnter: handleTooltipMouseEnter, onMouseLeave: handleTooltipMouseLeave },
                theme === 'none' && content,
                theme === 'inverse' && (React.createElement("div", { className: classNames(styles.content, styles.inverse, styles[size]) }, content)),
                theme === 'default' && (React.createElement("div", { className: classNames(styles.content, styles.default, styles[size]) }, content)))))));
}
export default Tooltip;
